import * as i0 from '@angular/core';
import * as i1 from './dialog.module';
import * as i2 from '@angular/common';
import * as i3 from './dialog.component';
import * as i4 from './dialog-close.directive';
import * as i5 from './draggable.directive';
import * as i6 from './built-in-dialogs/base.component';
import * as i7 from './built-in-dialogs/success.component';
import * as i8 from './built-in-dialogs/confirm.component';
import * as i9 from './built-in-dialogs/error.component';
export const BllDialogModuleNgFactory:i0.NgModuleFactory<i1.BllDialogModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.BllDialogComponent = (<any>(null as any));
var _decl0_12:i4.BllDialogCloseDirective = (<any>(null as any));
var _decl0_13:i5.BllDialogDraggableDirective = (<any>(null as any));
var _decl0_14:i6.BaseDialogComponent = (<any>(null as any));
var _decl0_15:i7.SuccessDialogComponent = (<any>(null as any));
var _decl0_16:i8.ConfirmDialogComponent = (<any>(null as any));
var _decl0_17:i9.ErrorDialogComponent = (<any>(null as any));
var _decl0_18:i2.AsyncPipe = (<any>(null as any));
var _decl0_19:i2.UpperCasePipe = (<any>(null as any));
var _decl0_20:i2.LowerCasePipe = (<any>(null as any));
var _decl0_21:i2.JsonPipe = (<any>(null as any));
var _decl0_22:i2.SlicePipe = (<any>(null as any));
var _decl0_23:i2.DecimalPipe = (<any>(null as any));
var _decl0_24:i2.PercentPipe = (<any>(null as any));
var _decl0_25:i2.TitleCasePipe = (<any>(null as any));
var _decl0_26:i2.CurrencyPipe = (<any>(null as any));
var _decl0_27:i2.DatePipe = (<any>(null as any));
var _decl0_28:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_29:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_30:i2.KeyValuePipe = (<any>(null as any));
var _decl0_31:i2.CommonModule = (<any>(null as any));
var _decl0_32:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_33:i0.ElementRef<any> = (<any>(null as any));
function _View_BllDialogComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_BllDialogComponent_1_1():void {
  if (_decl0_11.config.draggable) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    const currVal_1:any = true;
    currVal_1;
  }
}
function _View_BllDialogComponent_1_2():void {
  if ((_decl0_11.config.enableClose && _decl0_11.config.closeButton)) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_11.closeDialog()) !== false);
  }
}
function _View_BllDialogComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_11.config.backdrop;
  currVal_0;
  const currVal_1:any = _decl0_11.config.backdrop;
  currVal_1;
  const currVal_2:any = _decl0_11.styles;
  currVal_2;
  const currVal_3:any = _decl0_11.config.resizable;
  currVal_3;
  const currVal_4:any = _decl0_11.config.draggable;
  currVal_4;
  const currVal_5:any = (_decl0_11.config.enableClose && _decl0_11.config.closeButton);
  currVal_5;
}
function _View_BaseDialogComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_BaseDialogComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_SuccessDialogComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_SuccessDialogComponent_3_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_15.ref.close()) !== false);
}
function _View_ConfirmDialogComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmDialogComponent_4_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_16.ref.close(false)) !== false);
  const pd_1:any = ((<any>_decl0_16.ref.close(true)) !== false);
}
function _View_ErrorDialogComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_ErrorDialogComponent_5_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_17.ref.close()) !== false);
}
